
export const SUMMARY_PANEL_CONTROLS_ID = 'summary-panel-controls-wrapper';
